import {
  Box,
  Button,
  FormLabel,
  Image,
  Input,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { BiPodcast } from "react-icons/bi";
import {
  FcBusinessman,
  FcCamcorderPro,
  FcFilingCabinet,
  FcParallelTasks,
  FcStackOfPhotos,
} from "react-icons/fc";
import { GrMultiple } from "react-icons/gr";
import CreateModal from "../components/common/Modal/Modal";
import CheckboxInput from "../components/common/TextInputs/Checkbox";
import CreateInput from "../components/common/TextInputs/Input";
import Loading from "../components/common/ui/Loading";
import Card from "../components/Dashboard/Card";
import { useNavigator } from "../hooks/useNavigator";
import {
  getDashboardData,
  systemValueUpdate,
  uploadFile,
} from "../utils/api";
const Home = () => {
  const [systemValues, setSystemValues] = React.useState({});
  const [dashboardData, setDashboardData] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [type, setType] = React.useState("system");

  const toast = useToast();
  const getDashboardDataHandler = async () => {
    setLoading(true);
    const [success, data] = await getDashboardData();
    if (success) {
      setDashboardData(data);
      setSystemValues(data.systemValues);
      console.log(data?.systemValues?.adminCharges);
    }
    setLoading(false);
  };
  const [navigate, user] = useNavigator(() => {
    if (user) {
      getDashboardDataHandler();
    } else {
      navigate("/login");
    }
  });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const changeHandler = (e, name) => {
    setSystemValues((prev) => ({
      ...prev,
      [name]: e.target.value,
    }));
  };

  const handlePromotionalBannerUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setLoading(true);
    const [success, link] = await uploadFile(file);
    if (success) {
      setSystemValues((prev) => ({
        ...prev,
        promotionalBanner: link,
      }));
      toast({
        title: "Promotional banner uploaded",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } else {
      toast({
        title: "Upload failed",
        description: "Failed to upload promotional banner",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setLoading(false);
    e.target.value = "";
  };
  if (loading) {
    return <Loading />;
  }
  return (
    <Box sx={{ p: "10" }}>
      {user?.addAdmin ? (
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}>
          <Button
            onClick={() => {
              setType("system");
              onOpen();
            }}
            colorScheme="blue"
          >
            System Value
          </Button>
          <Button
            onClick={() => {
              setType("payment");
              onOpen1();
            }}
            colorScheme="blue"
          >
            Payment Gateway
          </Button>
        </Box>
      ) : (
        <div></div>
      )}
      <Text
        fontSize="4xl"
        fontWeight="bold"
        mb="5"
        sx={{
          padding: "1rem",
          display: "flex",
          alignItems: "center",
          gap: 2,
          borderBottom: "1px solid #eee",
        }}
      >
        Dashboard <FcFilingCabinet />
      </Text>
      <Box
        sx={{
          display: "flex",
          gap: "1rem",
          flexWrap: "wrap",
        }}
      >
        <Card
          icon={<BiPodcast size={24} />}
          color={"purple"}
          name="Videos"
          number={dashboardData?.movies}
        />
        <Card
          icon={<GrMultiple size={24} />}
          color={"pink"}
          name="Series"
          number={dashboardData?.series}
        />
        <Card
          icon={<FcBusinessman size={24} />}
          color="blue"
          name="Users"
          number={dashboardData?.users}
        />
        <Card
          icon={<FcStackOfPhotos size={24} />}
          color={"yellow"}
          name="Banners"
          number={dashboardData?.banners}
        />
        <Card
          icon={<FcParallelTasks size={24} />}
          color={"green"}
          name="Categories"
          number={dashboardData?.categories}
        />
        <Card
          icon={<FcCamcorderPro size={24} />}
          color={"red"}
          name="Subscription"
          number={dashboardData?.subscription}
        />
      </Box>
      <CreateModal
        isOpen={isOpen}
        onClose={onClose}
        title="System Settings"
        create={async () => {
          setLoading(true);
          const [success, data] = await systemValueUpdate(systemValues);
          if (success) {
            toast({
              title: "System Values Updated",
              description: "System Values Updated Successfully",
              status: "success",
              duration: 9000,
              isClosable: true,
            });
            getDashboardDataHandler();
          }
          onClose();
          setLoading(false);
        }}
      >
        <CreateInput
          tooltip={
            "Minimum Amount after which user can generate a redeem request"
          }
          name={"Redeem Amount (in ₹)"}
          value={systemValues?.redeemAmount}
          onChange={(e) => changeHandler(e, "redeemAmount")}
        />
        <CreateInput
          name={"Referral First (in ₹)"}
          value={systemValues?.referralFirst}
          onChange={(e) => changeHandler(e, "referralFirst")}
          tooltip={
            "The amount that person will get who will be at first of the chain"
          }
        />
        <CreateInput
          name={"Referral Second (in ₹)"}
          value={systemValues?.referralSecond}
          onChange={(e) => changeHandler(e, "referralSecond")}
          tooltip={
            "The amount that person will get who will be at second of the chain"
          }
        />
        <CreateInput
          name={"Referral Third (in ₹)"}
          value={systemValues?.referralThird}
          onChange={(e) => changeHandler(e, "referralThird")}
          tooltip={
            "The amount that person will get who will be at third of the chain"
          }
        />
        <CreateInput
          name={"Referral Four (in ₹)"}
          value={systemValues?.referralFour}
          onChange={(e) => changeHandler(e, "referralFour")}
          tooltip={
            "The amount that person will get who will be at fourth of the chain"
          }
        />
        <CreateInput
          name={"Referral-Five (in ₹)"}
          value={systemValues?.referralFive}
          onChange={(e) => changeHandler(e, "referralFive")}
          tooltip={
            "The amount that person will get who will be at fifth of the chain"
          }
        />
        <CreateInput
          name={"Referral Fixed Price (in ₹)"}
          value={systemValues?.referralFixedPrice}
          onChange={(e) => changeHandler(e, "referralFixedPrice")}
          tooltip={
            "The amount that person will get who will be after fifth in the chain"
          }
        />
        {/* <CreateInput
          name={"Referral Coin"}
          value={systemValues?.referralCoin}
          onChange={(e) => changeHandler(e, "referralCoin")}
          tooltip={
            "This is the amount that you will get if you redeem your referral code. eg. 1000"
          }
        /> */}
        <CreateInput
          name={"Promotional Coin (in ₹)"}
          value={systemValues?.promotionalCoin}
          onChange={(e) => changeHandler(e, "promotionalCoin")}
          tooltip={
            "Coin user will get after sharing promotional video of movies/series"
          }
        />
        <CreateInput
          name={"App Sharing Coin (in ₹)"}
          value={systemValues?.appSharingCoin}
          onChange={(e) => changeHandler(e, "appSharingCoin")}
          tooltip={"Coin user will get after app sharing."}
        />
        <CreateInput
          name={"Content Sharing Coin (in ₹)"}
          value={systemValues?.contentSharingCoin}
          onChange={(e) => changeHandler(e, "contentSharingCoin")}
          tooltip={"Coin user will get after sharing movies/series"}
        />
        <CreateInput
          name={"Reward Video Coin (in ₹)"}
          value={systemValues?.rewardVideoCoin}
          onChange={(e) => changeHandler(e, "rewardVideoCoin")}
          tooltip={
            "Coin user will get after watching video if he has reward plan subscription."
          }
        />
        <CreateInput
          name={"Admin Charges (in ₹)"}
          value={systemValues?.adminCharges}
          onChange={(e) => changeHandler(e, "adminCharges")}
          tooltip={
            "Charges that will be decuted from user wallet dusring withdrawal"
          }
        />
        <CreateInput
          name={"Upi Charges (in ₹)"}
          value={systemValues?.upiCharges}
          onChange={(e) => changeHandler(e, "upiCharges")}
          tooltip={
            "Charges that will be charged from user for UPI Verification"
          }
        />
        <CreateInput
          name={"Upload Charges (in ₹ per MB)"}
          value={systemValues?.uploadCharge}
          onChange={(e) => changeHandler(e, "uploadCharge")}
          tooltip={"Per MB charge for uploading the video"}
        />
        <CreateInput
          name={"Less Charge (in ₹)"}
          value={systemValues?.lessCharge}
          onChange={(e) => changeHandler(e, "lessCharge")}
          tooltip={"Less charge applied on the transaction"}
        />
        <CreateInput
          name={"View Amount (in ₹)"}
          value={systemValues?.viewAmount}
          onChange={(e) => changeHandler(e, "viewAmount")}
          tooltip={"The coins that user will get per view"}
        />
        <CreateInput
          name={"Tangent Career (in ₹)"}
          value={systemValues?.contestCharge}
          onChange={(e) => changeHandler(e, "contestCharge")}
          tooltip={
            "The amount that will be charged from user for enrolling in Tangent Career."
          }
        />
        <CreateInput
          name={"Login Text"}
          value={systemValues?.loginText}
          onChange={(e) => changeHandler(e, "loginText")}
          tooltip={"The text that will be dispalyed on Login Screen of App"}
        />
        <Box>
          <FormLabel fontSize="sm" fontWeight="medium">
            Promotional Banner
          </FormLabel>
          <Input
            type="file"
            accept="image/*"
            p={1}
            onChange={handlePromotionalBannerUpload}
          />
          {systemValues?.promotionalBanner && (
            <Image
              src={systemValues.promotionalBanner}
              alt="Promotional banner"
              mt={3}
              maxH="200px"
              rounded="md"
              border="1px solid"
              borderColor="gray.200"
            />
          )}
        </Box>
      </CreateModal>
      <CreateModal
        isOpen={isOpen1}
        onClose={onClose1}
        title="Payment Gateway"
        create={async () => {
          setLoading(true);
          const [success, data] = await systemValueUpdate(systemValues);
          if (success) {
            toast({
              title: "Payment Details Updated",
              description: "Payment Details Updated Successfully",
              status: "success",
              duration: 9000,
              isClosable: true,
            });
            getDashboardDataHandler();
          }
          onClose1();
          setLoading(false);
        }}
      >
        <CheckboxInput
          isChecked={systemValues?.isPhonePeEnabled}
          onChange={(e) =>
            changeHandler(
              {
                target: {
                  name: "isPhonePeEnabled",
                  value: e.target.checked,
                },
              },
              "isPhonePeEnabled"
            )
          }
          name="PhonePe"
        />
        <CheckboxInput
          isChecked={systemValues?.isRazorpayEnabled}
          onChange={(e) =>
            changeHandler(
              {
                target: {
                  name: "isRazorpayEnabled",
                  value: e.target.checked,
                },
              },
              "isRazorpayEnabled"
            )
          }
          name="Razorpay"
        />
        <CheckboxInput
          isChecked={systemValues?.isPaytmEnabled}
          onChange={(e) =>
            changeHandler(
              {
                target: {
                  name: "isPaytmEnabled",
                  value: e.target.checked,
                },
              },
              "isPaytmEnabled"
            )
          }
          name="PayTM"
        />
        <CreateInput
          name="PhonePe Merchant Key"
          value={systemValues?.phonePeMerchantKey}
          onChange={(e) => changeHandler(e, "phonePeMerchantKey")}
        />
        <CreateInput
          name="PhonePe Salt"
          value={systemValues?.phonePeSalt}
          onChange={(e) => changeHandler(e, "phonePeSalt")}
        />
        <CreateInput
          name="Razorpay Key"
          value={systemValues?.razorpayKey}
          onChange={(e) => changeHandler(e, "razorpayKey")}
        />
        <CreateInput
          name="Razorpay Secret"
          value={systemValues?.razorpaySecret}
          onChange={(e) => changeHandler(e, "razorpaySecret")}
        />
        <CreateInput
          name="Paytm Merchant Id"
          value={systemValues?.paytmMerchantId}
          onChange={(e) => changeHandler(e, "paytmMerchantId")}
        />
      </CreateModal>
    </Box>
  );
};

export default Home;
